<template>
  <ul class="sidebar-routes">
    <li v-for="(route, i) in $props.routes" :key="`SidebarRoute-${i}`">
      <router-link
        v-if="route.href"
        @click.native="closeMenu()"
        :to="{ name: route.href }"
        :title="route.description"
        :class="['general-anchor decorated', { active: $route.name === route.href }]"
      >
        <font-awesome-icon :icon="route.icon" />
        <span v-show="$props.textState">{{ route.description }}</span>
      </router-link>
      <a
        v-else
        @click.prevent="setChildrenState(i)"
        :title="route.description"
        class="general-anchor"
      >
        <font-awesome-icon :icon="route.icon" />
        <span v-show="$props.textState">{{ route.description }}</span>
      </a>
      <button
        v-if="hasChildren(route)"
        @click="setChildrenState(i)"
        class="sidebar-routes-more-cta"
        type="button"
      >
        <font-awesome-icon :icon="['fas', childrenState.includes(i) ? 'caret-up' : 'caret-down']" />
      </button>
      <sidebar-routes
        v-if="hasChildren(route) && childrenState.includes(i)"
        :routes="route.children"
        :textState="$props.textState"
      />
    </li>
  </ul>
</template>

<script>
const SidebarRoutes = () =>
  import(
    /* webpackChunkName: "SidebarComponent" */ "@/components/Global/Sidebar/Routes/SidebarRoutes.vue"
  );

export default {
  name: "SidebarRoutes",
  components: {
    SidebarRoutes
  },
  props: {
    /*
     * @property - routes
     * Sets routes of component
     */
    routes: {
      type: Array,
      required: true
    },
    /*
     * @property - textState
     * Defines if texts should be shown or hidden
     */
    textState: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      childrenState: []
    };
  },
  watch: {
    ["$route.name"](routeName) {
      if (routeName) {
        this.setChildrenStateRouteActive();
      }
    }
  },
  methods: {
    /*
     * @function - hasChildren
     * true if route argument has children in it, otherwise false
     * @param - route (Object) - route passed as argument
     */
    hasChildren(route) {
      return route.children && route.children.length;
    },
    /*
     * @function - setChildrenState
     * If index passed is already part of childrenState, then is removed (which means that is closed),
     * otherwise is pushed (which means that is opened)
     * @param - i (Number) - Index of current children
     */
    setChildrenState(i) {
      this.childrenState.includes(i)
        ? this.childrenState.splice(this.childrenState.indexOf(i), 1)
        : this.childrenState.push(i);
    },
    /*
     * @function - setChildrenStateRouteActive
     * If index passed is already part of childrenState, then is removed (which means that is closed),
     * otherwise is pushed (which means that is opened)
     * @param - i (Number) - Index of current children
     */
    setChildrenStateRouteActive() {
      this.$props.routes.forEach((route, i) => {
        if (route.children && !!route.children.length) {
          route.children.forEach(subRoute => {
            if (this.$route.name === subRoute.href && !this.childrenState.includes(i)) {
              this.setChildrenState(i);
            }
          });
        }
      });
    },
    closeMenu() {
      if (this.$store.state.Global.window.width >= this.$utils.styles.breakpoints.small) {
        return;
      }

      this.$bus.$emit("SidebarRoutes: anchor clicked");
    }
  },
  mounted() {
    this.setChildrenStateRouteActive();
  }
};
</script>

<style lang="scss" scoped>
.sidebar-routes {
  list-style: none;
  margin: 0;
  padding: 0 0 0 1.25rem;

  &-more-cta {
    @include fillVerticalTransition($white-raw, $dark-gray, $white-raw, $main-green, true);
    border: none;
    border-radius: 0.2rem;
    box-shadow: 0.2rem 0.2rem 0.25rem 0 rgba($dark-raw, 0.4);
    float: right;
    margin-left: 0.5rem;
    margin-top: 0.15rem;
    padding: 0;
    height: 1.3rem;
    width: 1.3rem;

    &::before {
      border-radius: 0.2rem;
    }
  }
}
</style>
